<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import RadioButton from '../../components/RadioButton.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'SurveyQ10EnqRating',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('satisfied_rating_5'), key: '5' },
        { text: this.$t('somewhat_satisfied_rating_4'), key: '4' },
        { text: this.$t('neither_rating_3'), key: '3' },
        { text: this.$t('somewhat_dissatisfied_rating_2'), key: '2' },
        { text: this.$t('dissatisfied_rating_1'), key: '1' }
      ]
    };
  },
  computed: {
    ...mapGetters(['enquiryRating'])
  },
  methods: {
    ...mapActions(['changeEnquiryRating']),

    change (event: number) {
      this.changeEnquiryRating(Number(event));
    },
    nextScreen () {
      // TODO navigate user to new Q11
      router.push({ path: '/survey/question11OptrRating/' });
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
      <p class="with-margin">{{ $t('survey_10_enq_rating_call') }}</p>
      <radio-button :text="data" @change="change($event)" :value="enquiryRating.toString()"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!enquiryRating"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
